import { useContext } from 'react';
import { SiteSettingsContext } from '@/context/SiteSettingsContext';

export const useSiteSettings = () => {
	const context = useContext(SiteSettingsContext);
	if (context === undefined) {
		throw new Error(
			'useSiteSettings must be used within a SiteSettingsProvider',
		);
	}
	return context;
};
